import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useMagister() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/magister/")
    .then((res: SuccessFetch<{
      payload: {
        magister_id: number
        magister_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.magister_name, value: item.magister_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/magister/").then((res: SuccessFetch<{
      payload: {
        magister_id: number
        magister_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.magister_name,
          value: item.magister_id?.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}